import React, {Component} from 'react';
import styled from 'styled-components';
import {brk} from "../styles/constants";
import ButtonUnderline from './ButtonUnderline'


const Container = styled.div`
   display: flex;
   width:100%;
   min-height : 400px;

   @media (max-width : ${brk.S}) {
    flex-direction : column;
  }
   
`;
const BlockLeft = styled.div`
   width : 50%;
   height : auto;
   
   @media (max-width : ${brk.S}) {
    width : 100%;
  }
`;


const BlockRight = styled.div`
   width : 50%;
   height : auto;
   @media (max-width : ${brk.S}) {
      width : 100%;
      min-height : 400px;
    }
`;

const Description = styled.div`
`;
const ContentBlock = styled.div`
    width : 70%;
    max-width : 350px;
    margin : auto;
    padding-top : 45px; 
    padding-bottom : 40px; 
   

`;


const BackgroundImage = styled.div`
    width: 100%;
    height: 100%;
	min-height: inherit;
	position: relative;
	display: block;
	background-size: cover !important;
	background-position : center !important;
`



class BlockImageRight extends Component {
    render() {
        const {
            block
        } = this.props;


        let title;
        if(block.title){
            title = <h2>{ block.title }</h2>;
        }

        let subtitle;
        if(block.subtitle){
            subtitle = <h3>{ block.subtitle }</h3>;
        }

        let text;
        if(block.textContent){
            text = <Description className={'description'} dangerouslySetInnerHTML={{ __html: block.textContent.childMarkdownRemark.html }}/>
        }

        let button;
        if(block.buttonLabel){
            button = <ButtonUnderline linkSlug={block.buttonLink} linkLabel={block.buttonLabel} />;

        }


        return (
            <Container >
                <BlockLeft>
                    <ContentBlock>
                        { title }
                        { subtitle }
                        { text }
                        { button }
                    </ContentBlock>
                </BlockLeft>
                <BlockRight>
                    <BackgroundImage  style={{ background: `url(${block.images[0].fluid.src})`}}
                    ></BackgroundImage>
                </BlockRight>


            </Container>
        )
    }
}


export default BlockImageRight;